import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) {

  }

  validar() {

    let valido = localStorage.getItem('valido');
    //alert(valido);
    //console.log(valido);
    return (valido === '1')

  }

  isAdmin() {
    let rol = localStorage.getItem('rol'); //JSON.parse(localStorage.getItem('rol')) || [];
    //let rol = JSON.parse(localStorage.getItem('rol')) || [];
    //console.log(rol);
    return (rol === 'admin')
  }

}
